/**
 * Voice search for quick search bar (mobile-friendly).
 * Uses Web Speech API to fill the search input; works with Shopify Search & Discovery.
 */
(function () {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SpeechRecognition) return;

  function init() {
    const quickSearch = document.querySelector('[data-quick-search]');
    const voiceBtn = document.querySelector('[data-voice-search]');
    const input = document.querySelector('.quick-search__input[data-input], .quick-search__input#search');
    if (!quickSearch || !voiceBtn || !input) return;

    const iconEl = voiceBtn.querySelector('.quick-search__voice-icon');
    const wavesEl = voiceBtn.querySelector('.quick-search__voice-waves');
    let recognition = null;
    let isListening = false;
    var silenceTimeout = null;
    var SILENCE_MS = 2000;

    function setListening(listening) {
      isListening = listening;
      voiceBtn.setAttribute('aria-pressed', listening ? 'true' : 'false');
      if (iconEl) iconEl.hidden = listening;
      if (wavesEl) {
        wavesEl.hidden = !listening;
      }
    }

    function stopListening() {
      if (silenceTimeout) {
        clearTimeout(silenceTimeout);
        silenceTimeout = null;
      }
      if (recognition) recognition.stop();
      setListening(false);
    }

    function startSilenceTimer() {
      if (silenceTimeout) clearTimeout(silenceTimeout);
      silenceTimeout = setTimeout(function () {
        silenceTimeout = null;
        stopListening();
      }, SILENCE_MS);
    }

    voiceBtn.addEventListener('click', function () {
      if (isListening) {
        stopListening();
        return;
      }

      recognition = new SpeechRecognition();
      recognition.continuous = true;
      recognition.interimResults = true;
      recognition.lang = document.documentElement.lang || 'en-US';

      recognition.onstart = function () {
        setListening(true);
        startSilenceTimer();
      };

      recognition.onresult = function (event) {
        startSilenceTimer();
        // Only use final results to avoid duplicated/garbled text (e.g. "moon moon moonstone moonstone ring")
        var newFinals = '';
        for (var i = event.resultIndex; i < event.results.length; i++) {
          if (event.results[i].isFinal) {
            newFinals += (newFinals ? ' ' : '') + event.results[i][0].transcript.trim();
          }
        }
        if (newFinals) {
          input.value = (input.value ? input.value + ' ' : '') + newFinals;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      };

      recognition.onend = function () {
        setListening(false);
      };

      recognition.onerror = function (event) {
        if (event.error !== 'aborted') setListening(false);
      };

      try {
        recognition.start();
      } catch (e) {
        setListening(false);
      }
    });

    // Stop voice when quick search closes
    const overlay = quickSearch.querySelector('[data-overlay]');
    const closeBtn = quickSearch.querySelector('[data-close-icon]');
    function onClose() {
      stopListening();
    }
    if (overlay) overlay.addEventListener('click', onClose);
    if (closeBtn) closeBtn.addEventListener('click', onClose);

    // Stop when form is submitted
    const form = quickSearch.querySelector('[data-quick-search-form]');
    if (form) form.addEventListener('submit', onClose);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
